import { __assign, __extends } from "tslib";
import * as _ from '@antv/util';
import Adjust from './adjust';
var Cache = _.Cache;
var Stack = /** @class */ (function (_super) {
    __extends(Stack, _super);
    function Stack(cfg) {
        var _this = _super.call(this, cfg) || this;
        var _a = cfg.adjustNames, adjustNames = _a === void 0 ? ['y'] : _a, _b = cfg.height, height = _b === void 0 ? NaN : _b, _c = cfg.size, size = _c === void 0 ? 10 : _c, _d = cfg.reverseOrder, reverseOrder = _d === void 0 ? false : _d;
        _this.adjustNames = adjustNames;
        _this.height = height;
        _this.size = size;
        _this.reverseOrder = reverseOrder;
        return _this;
    }
    /**
     * æ¹æ³å¥åæ¯ç»è¿æ°æ®åç»ãæ°æ®æ°å­åä¹åçäºç»´æ°ç»
     * @param groupDataArray åç»ä¹åçæ°æ®
     */
    Stack.prototype.process = function (groupDataArray) {
        var _a = this, yField = _a.yField, reverseOrder = _a.reverseOrder;
        // å¦æææå® y å­æ®µï¼é£ä¹æç§ y å­æ®µæ¥ stack
        // å¦åï¼æç§é«åº¦åå
        var d = yField ? this.processStack(groupDataArray) : this.processOneDimStack(groupDataArray);
        return reverseOrder ? this.reverse(d) : d;
    };
    Stack.prototype.reverse = function (groupedDataArray) {
        return groupedDataArray.slice(0).reverse();
    };
    Stack.prototype.processStack = function (groupDataArray) {
        var _a = this, xField = _a.xField, yField = _a.yField, reverseOrder = _a.reverseOrder;
        // å±å é¡ºåºç¿»è½¬
        var groupedDataArray = reverseOrder ? this.reverse(groupDataArray) : groupDataArray;
        // ç¨æ¥ç¼å­ï¼æ­£æ°åè´æ°çå å é®é¢
        var positive = new Cache();
        var negative = new Cache();
        return groupedDataArray.map(function (dataArray) {
            return dataArray.map(function (data) {
                var _a;
                var x = _.get(data, xField, 0);
                var y = _.get(data, [yField]);
                var xKey = x.toString();
                // todo æ¯å¦åºè¯¥å _originï¼å ä¸º y å¯è½åå°çå¼ä¸æ­£ç¡®ï¼æ¯å¦å symmetricï¼å stackï¼
                y = _.isArray(y) ? y[1] : y;
                if (!_.isNil(y)) {
                    var cache = y >= 0 ? positive : negative;
                    if (!cache.has(xKey)) {
                        cache.set(xKey, 0);
                    }
                    var xValue = cache.get(xKey);
                    var newXValue = y + xValue;
                    // å­èµ·æ¥
                    cache.set(xKey, newXValue);
                    return __assign(__assign({}, data), (_a = {}, _a[yField] = [xValue, newXValue], _a));
                }
                // æ²¡æä¿®æ¹ï¼åç´æ¥è¿å
                return data;
            });
        });
    };
    Stack.prototype.processOneDimStack = function (groupDataArray) {
        var _this = this;
        var _a = this, xField = _a.xField, height = _a.height, reverseOrder = _a.reverseOrder;
        var yField = 'y';
        // å¦æå±å çé¡ºåºç¿»è½¬
        var groupedDataArray = reverseOrder ? this.reverse(groupDataArray) : groupDataArray;
        // ç¼å­ç´¯å æ°æ®
        var cache = new Cache();
        return groupedDataArray.map(function (dataArray) {
            return dataArray.map(function (data) {
                var _a;
                var size = _this.size;
                var xValue = data[xField];
                // todo æ²¡æçå°è¿ä¸ª stack è®¡ç®åç
                var stackHeight = (size * 2) / height;
                if (!cache.has(xValue)) {
                    cache.set(xValue, stackHeight / 2); // åå§å¼å¤§å°
                }
                var stackValue = cache.get(xValue);
                // å¢å ä¸å± stackHeight
                cache.set(xValue, stackValue + stackHeight);
                return __assign(__assign({}, data), (_a = {}, _a[yField] = stackValue, _a));
            });
        });
    };
    return Stack;
}(Adjust));
export default Stack;
//# sourceMappingURL=stack.js.map